<template>
  <div class="card">
    <div class="card-top">
      <span class="name">{{ data.name }}</span>
      <a-button class="btn">{{ data.add }}</a-button>
    </div>
    <div class="introduce">
      {{ data.introduce }}
    </div>
    <div class="title" v-if="data.title">
      {{ data.title }}
    </div>
    <div class="explain">
      {{ data.explain }}
    </div>
  </div>
</template>
<script>
import { Button } from "ant-design-vue";
export default {
  name: "ram-card",
  components: {
    [Button.name]: Button
  },
  props: {
    data: Object
  },
  setup() {
    return {};
  }
};
</script>
<style scoped lang="less">
.card {
  margin-bottom: 16px;
  padding: 24px;
  text-align: left;
  background-color: #fff;
  -webkit-border-radius: 4px;
  border-radius: 4px;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.1);
  .card-top {
    display: flex;
    justify-content: space-between;
    span {
      color: #1d2129;
      font-weight: 500;
      font-size: 24px;
    }
    .btn {
      height: 32px;
      padding: 0 16px;
      color: #fff;
      font-weight: 400;
      font-size: 14px;
      background: #5e66f2;
      border-radius: 4px;
    }
  }
  .introduce {
    height: 20px;
    margin: 16px 0 8px 0;
    color: #4e5969;
    font-size: 12px;
    line-height: 20px;
  }
  .title {
    margin-bottom: 8px;
    color: #4e5969;
    font-weight: 500;
    font-size: 12px;
  }
  .explain {
    color: #4e5969;
    font-size: 12px;
  }
}
</style>
